<div class="row p-0 contenedor-detalle-siniestro mx-1 mt-2">
    <div class="col-md-6 col-12 borde-derecho my-3">
        <div class="row borde-inferior">
            <div class="col-md-12 col-12">
                <small class="titulo">ASEGURADOS</small>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-12 my-4 overflow-auto">
                <div class="seccion-tabla">
                    <table mat-table multiTemplateDataRows
                        [dataSource]="datosAsegurados.data | slice:(paginatorInfo?.pageStart ? paginatorInfo?.pageStart - 1 : 0):paginatorInfo?.pageEnd"
                        class="table d-xl-table d-md-table table-responsive my-2">
                        <ng-container matColumnDef="Estatus">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>Estatus</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{ element?.desc_estatus}}</td>
                        </ng-container>
                        <ng-container matColumnDef="Nombre">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>Nombre</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{element?.nombre}}</td>
                        </ng-container>
                        <ng-container matColumnDef="Edad">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>Edad</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{element?.edad}}</td>
                        </ng-container>


                        <!-- Sin resultados -->
                        <ng-container matColumnDef="noData">
                            <td mat-footer-cell *matFooterCellDef colspan="3">
                                <small>No se encontró ningún resultado</small>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayColumns;"
                            (click)="SelectRow(row, 'ASEGURADO')">
                        </tr>
                        <tr mat-footer-row *matFooterRowDef="['noData']"
                            [ngClass]="(datosAsegurados?.data?.length === 0) ? '':'ocultarPaginator'">
                        </tr>
                    </table>
                    <app-pagina-datos-tabla (eventPaginator)="paginatorInfo = $event" (click)="$event.stopPropagation()"
                        [style.visibility]="datosAsegurados?.data?.length >= 6 ? 'visible' : 'hidden'"
                        [showFisrtLastButton]="true" [registerPerPage]="5"
                        [totalLength]="datosAsegurados?.data?.length">
                    </app-pagina-datos-tabla>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-6 col-12 borde-derecho my-3">
        <div class="row borde-inferior">
            <div class="col-md-12 col-12">
                <small class="titulo">TERCEROS</small>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-12 my-4 overflow-auto">
                <div class="seccion-tabla">
                    <table mat-table multiTemplateDataRows [dataSource]="datosTerceros.data | slice:(paginatorInfoTer?.pageStart ? paginatorInfoTer?.pageStart - 1 : 0):paginatorInfoTer?.pageEnd"
                        class="table d-xl-table d-md-table table-responsive my-2">
                        <ng-container matColumnDef="Estatus">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>TipoTercero</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{ element?.desc_estatus}}</td>
                        </ng-container>
                        <ng-container matColumnDef="Nombre">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>Nombre</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{element?.nombre}}</td>
                        </ng-container>
                        <ng-container matColumnDef="Edad">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>Edad</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{element?.edad}}</td>
                        </ng-container>

                        <!-- Sin resultados -->
                        <ng-container matColumnDef="noData">
                            <td mat-footer-cell *matFooterCellDef colspan="3">
                                <small>No se encontró ningún resultado</small>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayColumns;" (click)="SelectRow(row, 'TERCEROS')">
                        </tr>
                        <tr mat-footer-row *matFooterRowDef="['noData']"
                            [ngClass]="(datosTerceros?.data?.length === 0) ? '':'ocultarPaginator'"></tr>
                    </table>
                    <app-pagina-datos-tabla (eventPaginator)="paginatorInfoTer = $event" (click)="$event.stopPropagation()"
                        [style.visibility]="datosTerceros?.data?.length >= 6 ? 'visible' : 'hidden'"
                        [showFisrtLastButton]="true" [registerPerPage]="5"
                        [totalLength]="datosTerceros?.data?.length">
                    </app-pagina-datos-tabla>
                </div>
            </div>
        </div>

    </div>
</div>